import { SET_RECIPIENT_NAMES } from "../actions/action.types";

export const recipientNames = (state = [], action: any) => {
  if (action.type === SET_RECIPIENT_NAMES) return action.payload;
  else return state;
};
